module.exports = __webpack_public_path__ + "img/case15-中国地质大学.f37af700.png";